<template>
    <tr>
        <td>
            {{ campaign.index + 1 }}
        </td>
        <td class="p1b">
            {{ campaign.id }}
        </td>
        <td style="max-width: 400px">
            <a :href="`/campaigns/${campaign.id}`" target="_blank">
                {{ campaign.title }}
            </a>
        </td>
        <td>
            <p 
                :class="campaign.profileStatus ? campaign.profileStatus.split(' ').join('-') : ''"
                class="p-2 profile-status"
            >
                {{ campaign.profileStatus || '-'}}
            </p>
        </td>
        <td>
            {{ campaign.email }}
        </td>
        <td class="py-3 text-center">
            <label class="switch">
                <input 
                    type="checkbox"
                    @change="switchFeatured"
                    v-model="isFeatured"
                >
                <span class="slider round">{{isFeatured ? 'on' : 'off'}}</span>
            </label>
        </td>
        <td class="text-center py-3">
             <label class="switch">
                <input 
                    type="checkbox"
                    @change="toggleHidden"
                    v-model="hidden"
                >
                <span class="slider round">{{hidden ? 'on' : 'off'}}</span>
            </label>
        </td>
        <td class="py-3">
            <label class="switch">
                <input 
                    type="checkbox"
                    @change="toggleCrosspromoterBadge"
                    v-model="crosspromoter"
                >
                <span class="slider round">{{crosspromoter ? 'on' : 'off'}}</span>
            </label>
        </td>
        <td class="text-center">
            <label class="switch">
                <input 
                    type="checkbox"
                    @change="toggleIndemand"
                    v-model="indemand"
                >
                <span class="slider round">{{indemand ? 'on' : 'off'}}</span>
            </label>
        </td>
        <td class="text-center">
            <label class="switch">
                <input 
                    type="checkbox"
                    @change="toggleAccess"
                    v-model="manageCommunityAccess"
                >
                <span class="slider round">{{manageCommunityAccess ? 'on' : 'off'}}</span>
            </label>
        </td>
    </tr>
</template>

<script>
import {updateData} from "../../../firebaseCRUD";
import {toggleFeatured} from "../../FeaturedCampaigns/featured.service";
import { message } from 'ant-design-vue'

export default {
    props: [
        'campaign'
    ],
    data: function () {
        return {
            hidden: this.campaign.hidden,
            isFeatured: this.campaign.featured,
            crosspromoter: this.campaign.crosspromoter || false,
            indemand: this.campaign.indemand || false,
            manageCommunityAccess: this.campaign.manageCommunityAccess || false
        }
    },
    methods: {
        toggleHidden: function () {
            updateData({
                id: this.campaign.id,
                data: { hidden: this.hidden || null },
                collection: 'campaigns'
            })
                .then(()=> {
                    message.success('Successfully updated')
                    this.$emit('updateCampaign', this.campaign.id, 'hidden', this.hidden || null)
                })
                .catch(e => {
                    message.error('Something went wrong');
                    console.log('Error updating campaign visibility', e)
                })
        },
        toggleCrosspromoterBadge: function() {
            updateData({
                id: this.campaign.id,
                data: {
                    crosspromoter: this.crosspromoter || false
                },
                collection: 'campaigns'
            })
            .then(() => {
                message.success('Successfully updated')
                this.$emit('updateCampaign', this.campaign.id, 'crosspromoter', this.crosspromoter || false)
            })
            .catch(e => {
                message.error('Something went wrong');
                console.log('Error updating campaign badge', e)
            })
        },
        switchFeatured() {
            toggleFeatured(this.campaign.id, this.isFeatured)
                .then(()=> {
                    message.success('Successfully updated')
                    this.$emit('updateCampaign', this.campaign.id, 'featured', this.isFeatured)
                })
                .catch( e => {
                    message.error('Something went wrong');
                    console.log('Error while setting campaign as featured', e)
                })
        },
        toggleIndemand: function() {
            updateData({
                id: this.campaign.id,
                data: { indemand: this.indemand },
                collection: 'campaigns'
            })
            .then(()=> {
                message.success('Successfully updated')
                this.$emit('updateCampaign', this.campaign.id, 'indemand', this.indemand)

            })
            .catch(e => {
                message.error('Something went wrong');
                console.log('Error updating campaign indemand status', e)
            })    
        },
        toggleAccess(){
            updateData({
                id: this.campaign.id,
                data: { manageCommunityAccess: this.manageCommunityAccess },
                collection: 'campaigns'
            })
            .then(()=> {
                message.success('Successfully updated')
                this.$emit('updateCampaign', this.campaign.id, 'manageCommunityAccess', this.manageCommunityAccess)
            })
            .catch(e => {
                message.error('Something went wrong');
                console.log('Error updating campaign collab permission', e)
            })    
        }
    }
}
</script>


<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  height: 22px;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
  font-size: 0;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider {
  background-color: #0ACF97;
}

input:focus + .slider {
  box-shadow: 0 0 1px #0ACF97;
}

input:checked + .slider:before {
  -webkit-transform: translateX(36px);
  -ms-transform: translateX(36px);
  transform: translateX(36px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.profile-status {
    color: #333;
    font-weight: bold;
    &.trial {
        background: rgb(255, 184, 48)
    }

    &.trial-expired {
        background: rgb(255, 107, 107)
    }

    &.subscribed {
        background: rgb(61, 178, 255)
    }

    &.subscription-canceled {
        background: rgba(236, 98, 116, 0.88)
    }
}


</style>